module.exports = __webpack_public_path__ + "img/makimono_modal_pc.86e930dd.png";